module.exports = __webpack_public_path__ + "static/img/premier_league.1eedb1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/bg/old/premier_league.jpg
// module id = bWps
// module chunks = 1